import Vue from 'vue';
import Component from 'vue-class-component';
import axios from 'axios';

function _typeof(obj) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) {
    return typeof obj;
  } : function (obj) {
    return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
  }, _typeof(obj);
}

function __decorate(decorators, target, key, desc) {
  var c = arguments.length,
      r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
      d;
  if ((typeof Reflect === "undefined" ? "undefined" : _typeof(Reflect)) === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) {
    if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  }
  return c > 3 && r && Object.defineProperty(target, key, r), r;
}

function createCommonjsModule(fn, module) {
	return module = { exports: {} }, fn(module, module.exports), module.exports;
}

var pipwerksScormApiWrapper = createCommonjsModule(function (module, exports) {
  (function (e, a) {
    for (var i in a) {
      e[i] = a[i];
    }
  })(exports,
  /******/
  function (modules) {
    // webpackBootstrap

    /******/
    // The module cache

    /******/
    var installedModules = {};
    /******/
    // The require function

    /******/

    function __webpack_require__(moduleId) {
      /******/
      // Check if module is in cache

      /******/
      if (installedModules[moduleId])
        /******/
        return installedModules[moduleId].exports;
      /******/
      // Create a new module (and put it into the cache)

      /******/

      var module = installedModules[moduleId] = {
        /******/
        exports: {},

        /******/
        id: moduleId,

        /******/
        loaded: false
        /******/

      };
      /******/
      // Execute the module function

      /******/

      modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
      /******/
      // Flag the module as loaded

      /******/

      module.loaded = true;
      /******/
      // Return the exports of the module

      /******/

      return module.exports;
      /******/
    }
    /******/
    // expose the modules object (__webpack_modules__)

    /******/


    __webpack_require__.m = modules;
    /******/
    // expose the module cache

    /******/

    __webpack_require__.c = installedModules;
    /******/
    // on error function for async loading

    /******/

    __webpack_require__.oe = function (err) {
      throw err;
    };
    /******/
    // __webpack_public_path__

    /******/


    __webpack_require__.p = "";
    /******/
    // Load entry module and return exports

    /******/

    return __webpack_require__(__webpack_require__.s = 1);
    /******/
  }
  /************************************************************************/

  /******/
  ([
  /* 0 */

  /***/
  function (module, exports) {
    /*global console*/

    /* ===========================================================
    
    pipwerks SCORM Wrapper for JavaScript
    v1.1.20150614
    
    Created by Philip Hutchison, January 2008-2014
    https://github.com/pipwerks/scorm-api-wrapper
    
    Copyright (c) Philip Hutchison
    MIT-style license: http://pipwerks.mit-license.org/
    
    This wrapper works with both SCORM 1.2 and SCORM 2004.
    
    Inspired by APIWrapper.js, created by the ADL and
    Concurrent Technologies Corporation, distributed by
    the ADL (http://www.adlnet.gov/scorm).
    
    SCORM.API.find() and SCORM.API.get() functions based
    on ADL code, modified by Mike Rustici
    (http://www.scorm.com/resources/apifinder/SCORMAPIFinder.htm),
    further modified by Philip Hutchison
    
    =============================================================== */
    var pipwerks = {}; //pipwerks 'namespace' helps ensure no conflicts with possible other "SCORM" variables

    pipwerks.UTILS = {}; //For holding UTILS functions

    pipwerks.debug = {
      isActive: true
    }; //Enable (true) or disable (false) for debug mode

    pipwerks.SCORM = {
      //Define the SCORM object
      version: null,
      //Store SCORM version.
      handleCompletionStatus: true,
      //Whether or not the wrapper should automatically handle the initial completion status
      handleExitMode: true,
      //Whether or not the wrapper should automatically handle the exit mode
      API: {
        handle: null,
        isFound: false
      },
      //Create API child object
      connection: {
        isActive: false
      },
      //Create connection child object
      data: {
        completionStatus: null,
        exitStatus: null
      },
      //Create data child object
      debug: {} //Create debug child object

    };
    /* --------------------------------------------------------------------------------
       pipwerks.SCORM.isAvailable
       A simple function to allow Flash ExternalInterface to confirm
       presence of JS wrapper before attempting any LMS communication.
    
       Parameters: none
       Returns:    Boolean (true)
    ----------------------------------------------------------------------------------- */

    pipwerks.SCORM.isAvailable = function () {
      return true;
    }; // ------------------------------------------------------------------------- //
    // --- SCORM.API functions ------------------------------------------------- //
    // ------------------------------------------------------------------------- //

    /* -------------------------------------------------------------------------
       pipwerks.SCORM.API.find(window)
       Looks for an object named API in parent and opener windows
    
       Parameters: window (the browser window object).
       Returns:    Object if API is found, null if no API found
    ---------------------------------------------------------------------------- */


    pipwerks.SCORM.API.find = function (win) {
      var API = null,
          findAttempts = 0,
          findAttemptLimit = 500,
          traceMsgPrefix = "SCORM.API.find",
          trace = pipwerks.UTILS.trace,
          scorm = pipwerks.SCORM;

      while (!win.API && !win.API_1484_11 && win.parent && win.parent != win && findAttempts <= findAttemptLimit) {
        findAttempts++;
        win = win.parent;
      } //If SCORM version is specified by user, look for specific API


      if (scorm.version) {
        switch (scorm.version) {
          case "2004":
            if (win.API_1484_11) {
              API = win.API_1484_11;
            } else {
              trace(traceMsgPrefix + ": SCORM version 2004 was specified by user, but API_1484_11 cannot be found.");
            }

            break;

          case "1.2":
            if (win.API) {
              API = win.API;
            } else {
              trace(traceMsgPrefix + ": SCORM version 1.2 was specified by user, but API cannot be found.");
            }

            break;
        }
      } else {
        //If SCORM version not specified by user, look for APIs
        if (win.API_1484_11) {
          //SCORM 2004-specific API.
          scorm.version = "2004"; //Set version

          API = win.API_1484_11;
        } else if (win.API) {
          //SCORM 1.2-specific API
          scorm.version = "1.2"; //Set version

          API = win.API;
        }
      }

      if (API) {
        trace(traceMsgPrefix + ": API found. Version: " + scorm.version);
        trace("API: " + API);
      } else {
        trace(traceMsgPrefix + ": Error finding API. \nFind attempts: " + findAttempts + ". \nFind attempt limit: " + findAttemptLimit);
      }

      return API;
    };
    /* -------------------------------------------------------------------------
       pipwerks.SCORM.API.get()
       Looks for an object named API, first in the current window's frame
       hierarchy and then, if necessary, in the current window's opener window
       hierarchy (if there is an opener window).
    
       Parameters:  None.
       Returns:     Object if API found, null if no API found
    ---------------------------------------------------------------------------- */


    pipwerks.SCORM.API.get = function () {
      var API = null,
          win = window,
          scorm = pipwerks.SCORM,
          find = scorm.API.find,
          trace = pipwerks.UTILS.trace;
      API = find(win);

      if (!API && win.parent && win.parent != win) {
        API = find(win.parent);
      }

      if (!API && win.top && win.top.opener) {
        API = find(win.top.opener);
      } //Special handling for Plateau
      //Thanks to Joseph Venditti for the patch


      if (!API && win.top && win.top.opener && win.top.opener.document) {
        API = find(win.top.opener.document);
      }

      if (API) {
        scorm.API.isFound = true;
      } else {
        trace("API.get failed: Can't find the API!");
      }

      return API;
    };
    /* -------------------------------------------------------------------------
       pipwerks.SCORM.API.getHandle()
       Returns the handle to API object if it was previously set
    
       Parameters:  None.
       Returns:     Object (the pipwerks.SCORM.API.handle variable).
    ---------------------------------------------------------------------------- */


    pipwerks.SCORM.API.getHandle = function () {
      var API = pipwerks.SCORM.API;

      if (!API.handle && !API.isFound) {
        API.handle = API.get();
      }

      return API.handle;
    }; // ------------------------------------------------------------------------- //
    // --- pipwerks.SCORM.connection functions --------------------------------- //
    // ------------------------------------------------------------------------- //

    /* -------------------------------------------------------------------------
       pipwerks.SCORM.connection.initialize()
       Tells the LMS to initiate the communication session.
    
       Parameters:  None
       Returns:     Boolean
    ---------------------------------------------------------------------------- */


    pipwerks.SCORM.connection.initialize = function () {
      var success = false,
          scorm = pipwerks.SCORM,
          completionStatus = scorm.data.completionStatus,
          trace = pipwerks.UTILS.trace,
          makeBoolean = pipwerks.UTILS.StringToBoolean,
          debug = scorm.debug,
          traceMsgPrefix = "SCORM.connection.initialize ";
      trace("connection.initialize called.");

      if (!scorm.connection.isActive) {
        var API = scorm.API.getHandle(),
            errorCode = 0;

        if (API) {
          switch (scorm.version) {
            case "1.2":
              success = makeBoolean(API.LMSInitialize(""));
              break;

            case "2004":
              success = makeBoolean(API.Initialize(""));
              break;
          }

          if (success) {
            //Double-check that connection is active and working before returning 'true' boolean
            errorCode = debug.getCode();

            if (errorCode !== null && errorCode === 0) {
              scorm.connection.isActive = true;

              if (scorm.handleCompletionStatus) {
                //Automatically set new launches to incomplete
                completionStatus = scorm.status("get");

                if (completionStatus) {
                  switch (completionStatus) {
                    //Both SCORM 1.2 and 2004
                    case "not attempted":
                      scorm.status("set", "incomplete");
                      break;
                    //SCORM 2004 only

                    case "unknown":
                      scorm.status("set", "incomplete");
                      break;
                    //Additional options, presented here in case you'd like to use them
                    //case "completed"  : break;
                    //case "incomplete" : break;
                    //case "passed"     : break;    //SCORM 1.2 only
                    //case "failed"     : break;    //SCORM 1.2 only
                    //case "browsed"    : break;    //SCORM 1.2 only
                  } //Commit changes


                  scorm.save();
                }
              }
            } else {
              success = false;
              trace(traceMsgPrefix + "failed. \nError code: " + errorCode + " \nError info: " + debug.getInfo(errorCode));
            }
          } else {
            errorCode = debug.getCode();

            if (errorCode !== null && errorCode !== 0) {
              trace(traceMsgPrefix + "failed. \nError code: " + errorCode + " \nError info: " + debug.getInfo(errorCode));
            } else {
              trace(traceMsgPrefix + "failed: No response from server.");
            }
          }
        } else {
          trace(traceMsgPrefix + "failed: API is null.");
        }
      } else {
        trace(traceMsgPrefix + "aborted: Connection already active.");
      }

      return success;
    };
    /* -------------------------------------------------------------------------
       pipwerks.SCORM.connection.terminate()
       Tells the LMS to terminate the communication session
    
       Parameters:  None
       Returns:     Boolean
    ---------------------------------------------------------------------------- */


    pipwerks.SCORM.connection.terminate = function () {
      var success = false,
          scorm = pipwerks.SCORM,
          exitStatus = scorm.data.exitStatus,
          completionStatus = scorm.data.completionStatus,
          trace = pipwerks.UTILS.trace,
          makeBoolean = pipwerks.UTILS.StringToBoolean,
          debug = scorm.debug,
          traceMsgPrefix = "SCORM.connection.terminate ";

      if (scorm.connection.isActive) {
        var API = scorm.API.getHandle(),
            errorCode = 0;

        if (API) {
          if (scorm.handleExitMode && !exitStatus) {
            if (completionStatus !== "completed" && completionStatus !== "passed") {
              switch (scorm.version) {
                case "1.2":
                  success = scorm.set("cmi.core.exit", "suspend");
                  break;

                case "2004":
                  success = scorm.set("cmi.exit", "suspend");
                  break;
              }
            } else {
              switch (scorm.version) {
                case "1.2":
                  success = scorm.set("cmi.core.exit", "logout");
                  break;

                case "2004":
                  success = scorm.set("cmi.exit", "normal");
                  break;
              }
            }
          } //Ensure we persist the data


          success = scorm.save();

          if (success) {
            switch (scorm.version) {
              case "1.2":
                success = makeBoolean(API.LMSFinish(""));
                break;

              case "2004":
                success = makeBoolean(API.Terminate(""));
                break;
            }

            if (success) {
              scorm.connection.isActive = false;
            } else {
              errorCode = debug.getCode();
              trace(traceMsgPrefix + "failed. \nError code: " + errorCode + " \nError info: " + debug.getInfo(errorCode));
            }
          }
        } else {
          trace(traceMsgPrefix + "failed: API is null.");
        }
      } else {
        trace(traceMsgPrefix + "aborted: Connection already terminated.");
      }

      return success;
    }; // ------------------------------------------------------------------------- //
    // --- pipwerks.SCORM.data functions --------------------------------------- //
    // ------------------------------------------------------------------------- //

    /* -------------------------------------------------------------------------
       pipwerks.SCORM.data.get(parameter)
       Requests information from the LMS.
    
       Parameter: parameter (string, name of the SCORM data model element)
       Returns:   string (the value of the specified data model element)
    ---------------------------------------------------------------------------- */


    pipwerks.SCORM.data.get = function (parameter) {
      var value = null,
          scorm = pipwerks.SCORM,
          trace = pipwerks.UTILS.trace,
          debug = scorm.debug,
          traceMsgPrefix = "SCORM.data.get(" + parameter + ") ";

      if (scorm.connection.isActive) {
        var API = scorm.API.getHandle(),
            errorCode = 0;

        if (API) {
          switch (scorm.version) {
            case "1.2":
              value = API.LMSGetValue(parameter);
              break;

            case "2004":
              value = API.GetValue(parameter);
              break;
          }

          errorCode = debug.getCode(); //GetValue returns an empty string on errors
          //If value is an empty string, check errorCode to make sure there are no errors

          if (value !== "" || errorCode === 0) {
            //GetValue is successful.  
            //If parameter is lesson_status/completion_status or exit status, let's
            //grab the value and cache it so we can check it during connection.terminate()
            switch (parameter) {
              case "cmi.core.lesson_status":
              case "cmi.completion_status":
                scorm.data.completionStatus = value;
                break;

              case "cmi.core.exit":
              case "cmi.exit":
                scorm.data.exitStatus = value;
                break;
            }
          } else {
            trace(traceMsgPrefix + "failed. \nError code: " + errorCode + "\nError info: " + debug.getInfo(errorCode));
          }
        } else {
          trace(traceMsgPrefix + "failed: API is null.");
        }
      } else {
        trace(traceMsgPrefix + "failed: API connection is inactive.");
      }

      trace(traceMsgPrefix + " value: " + value);
      return String(value);
    };
    /* -------------------------------------------------------------------------
       pipwerks.SCORM.data.set()
       Tells the LMS to assign the value to the named data model element.
       Also stores the SCO's completion status in a variable named
       pipwerks.SCORM.data.completionStatus. This variable is checked whenever
       pipwerks.SCORM.connection.terminate() is invoked.
    
       Parameters: parameter (string). The data model element
                   value (string). The value for the data model element
       Returns:    Boolean
    ---------------------------------------------------------------------------- */


    pipwerks.SCORM.data.set = function (parameter, value) {
      var success = false,
          scorm = pipwerks.SCORM,
          trace = pipwerks.UTILS.trace,
          makeBoolean = pipwerks.UTILS.StringToBoolean,
          debug = scorm.debug,
          traceMsgPrefix = "SCORM.data.set(" + parameter + ") ";

      if (scorm.connection.isActive) {
        var API = scorm.API.getHandle(),
            errorCode = 0;

        if (API) {
          switch (scorm.version) {
            case "1.2":
              success = makeBoolean(API.LMSSetValue(parameter, value));
              break;

            case "2004":
              success = makeBoolean(API.SetValue(parameter, value));
              break;
          }

          if (success) {
            if (parameter === "cmi.core.lesson_status" || parameter === "cmi.completion_status") {
              scorm.data.completionStatus = value;
            }
          } else {
            errorCode = debug.getCode();
            trace(traceMsgPrefix + "failed. \nError code: " + errorCode + ". \nError info: " + debug.getInfo(errorCode));
          }
        } else {
          trace(traceMsgPrefix + "failed: API is null.");
        }
      } else {
        trace(traceMsgPrefix + "failed: API connection is inactive.");
      }

      return success;
    };
    /* -------------------------------------------------------------------------
       pipwerks.SCORM.data.save()
       Instructs the LMS to persist all data to this point in the session
    
       Parameters: None
       Returns:    Boolean
    ---------------------------------------------------------------------------- */


    pipwerks.SCORM.data.save = function () {
      var success = false,
          scorm = pipwerks.SCORM,
          trace = pipwerks.UTILS.trace,
          makeBoolean = pipwerks.UTILS.StringToBoolean,
          traceMsgPrefix = "SCORM.data.save failed";

      if (scorm.connection.isActive) {
        var API = scorm.API.getHandle();

        if (API) {
          switch (scorm.version) {
            case "1.2":
              success = makeBoolean(API.LMSCommit(""));
              break;

            case "2004":
              success = makeBoolean(API.Commit(""));
              break;
          }
        } else {
          trace(traceMsgPrefix + ": API is null.");
        }
      } else {
        trace(traceMsgPrefix + ": API connection is inactive.");
      }

      return success;
    };

    pipwerks.SCORM.status = function (action, status) {
      var success = false,
          scorm = pipwerks.SCORM,
          trace = pipwerks.UTILS.trace,
          traceMsgPrefix = "SCORM.getStatus failed",
          cmi = "";

      if (action !== null) {
        switch (scorm.version) {
          case "1.2":
            cmi = "cmi.core.lesson_status";
            break;

          case "2004":
            cmi = "cmi.completion_status";
            break;
        }

        switch (action) {
          case "get":
            success = scorm.data.get(cmi);
            break;

          case "set":
            if (status !== null) {
              success = scorm.data.set(cmi, status);
            } else {
              success = false;
              trace(traceMsgPrefix + ": status was not specified.");
            }

            break;

          default:
            success = false;
            trace(traceMsgPrefix + ": no valid action was specified.");
        }
      } else {
        trace(traceMsgPrefix + ": action was not specified.");
      }

      return success;
    }; // ------------------------------------------------------------------------- //
    // --- pipwerks.SCORM.debug functions -------------------------------------- //
    // ------------------------------------------------------------------------- //

    /* -------------------------------------------------------------------------
       pipwerks.SCORM.debug.getCode
       Requests the error code for the current error state from the LMS
    
       Parameters: None
       Returns:    Integer (the last error code).
    ---------------------------------------------------------------------------- */


    pipwerks.SCORM.debug.getCode = function () {
      var scorm = pipwerks.SCORM,
          API = scorm.API.getHandle(),
          trace = pipwerks.UTILS.trace,
          code = 0;

      if (API) {
        switch (scorm.version) {
          case "1.2":
            code = parseInt(API.LMSGetLastError(), 10);
            break;

          case "2004":
            code = parseInt(API.GetLastError(), 10);
            break;
        }
      } else {
        trace("SCORM.debug.getCode failed: API is null.");
      }

      return code;
    };
    /* -------------------------------------------------------------------------
       pipwerks.SCORM.debug.getInfo()
       "Used by a SCO to request the textual description for the error code
       specified by the value of [errorCode]."
    
       Parameters: errorCode (integer).
       Returns:    String.
    ----------------------------------------------------------------------------- */


    pipwerks.SCORM.debug.getInfo = function (errorCode) {
      var scorm = pipwerks.SCORM,
          API = scorm.API.getHandle(),
          trace = pipwerks.UTILS.trace,
          result = "";

      if (API) {
        switch (scorm.version) {
          case "1.2":
            result = API.LMSGetErrorString(errorCode.toString());
            break;

          case "2004":
            result = API.GetErrorString(errorCode.toString());
            break;
        }
      } else {
        trace("SCORM.debug.getInfo failed: API is null.");
      }

      return String(result);
    };
    /* -------------------------------------------------------------------------
       pipwerks.SCORM.debug.getDiagnosticInfo
       "Exists for LMS specific use. It allows the LMS to define additional
       diagnostic information through the API Instance."
    
       Parameters: errorCode (integer).
       Returns:    String (Additional diagnostic information about the given error code).
    ---------------------------------------------------------------------------- */


    pipwerks.SCORM.debug.getDiagnosticInfo = function (errorCode) {
      var scorm = pipwerks.SCORM,
          API = scorm.API.getHandle(),
          trace = pipwerks.UTILS.trace,
          result = "";

      if (API) {
        switch (scorm.version) {
          case "1.2":
            result = API.LMSGetDiagnostic(errorCode);
            break;

          case "2004":
            result = API.GetDiagnostic(errorCode);
            break;
        }
      } else {
        trace("SCORM.debug.getDiagnosticInfo failed: API is null.");
      }

      return String(result);
    }; // ------------------------------------------------------------------------- //
    // --- Shortcuts! ---------------------------------------------------------- //
    // ------------------------------------------------------------------------- //
    // Because nobody likes typing verbose code.


    pipwerks.SCORM.init = pipwerks.SCORM.connection.initialize;
    pipwerks.SCORM.get = pipwerks.SCORM.data.get;
    pipwerks.SCORM.set = pipwerks.SCORM.data.set;
    pipwerks.SCORM.save = pipwerks.SCORM.data.save;
    pipwerks.SCORM.quit = pipwerks.SCORM.connection.terminate; // ------------------------------------------------------------------------- //
    // --- pipwerks.UTILS functions -------------------------------------------- //
    // ------------------------------------------------------------------------- //

    /* -------------------------------------------------------------------------
       pipwerks.UTILS.StringToBoolean()
       Converts 'boolean strings' into actual valid booleans.
    
       (Most values returned from the API are the strings "true" and "false".)
    
       Parameters: String
       Returns:    Boolean
    ---------------------------------------------------------------------------- */

    pipwerks.UTILS.StringToBoolean = function (value) {
      var t = _typeof(value);

      switch (t) {
        //typeof new String("true") === "object", so handle objects as string via fall-through. 
        //See https://github.com/pipwerks/scorm-api-wrapper/issues/3
        case "object":
        case "string":
          return /(true|1)/i.test(value);

        case "number":
          return !!value;

        case "boolean":
          return value;

        case "undefined":
          return null;

        default:
          return false;
      }
    };
    /* -------------------------------------------------------------------------
       pipwerks.UTILS.trace()
       Displays error messages when in debug mode.
    
       Parameters: msg (string)
       Return:     None
    ---------------------------------------------------------------------------- */


    pipwerks.UTILS.trace = function (msg) {
      if (pipwerks.debug.isActive) {
        if (window.console && window.console.log) {
          window.console.log(msg);
        }
      }
    };
    /*** EXPORTS FROM exports-loader ***/


    module.exports = pipwerks;
    /***/
  },
  /* 1 */

  /***/
  function (module, exports, __webpack_require__) {
    module.exports = __webpack_require__(0);
    /***/
  }
  /******/
  ]));
});

// SCORM 2004 requires timeinterval to be formatted as:
// P[yY][mM][dD][T[hH][nM][s[.s]S]]
function ConvertMilliSecondsIntoSCORM2004Time(intTotalMilliseconds) {
    let ScormTime = '';
    let HundredthsOfASecond; // decrementing counter - work at the hundreths of a second level because that is the maximum precision required
    const HUNDREDTHS_PER_SECOND = 100;
    const HUNDREDTHS_PER_MINUTE = HUNDREDTHS_PER_SECOND * 60;
    const HUNDREDTHS_PER_HOUR = HUNDREDTHS_PER_MINUTE * 60;
    const HUNDREDTHS_PER_DAY = HUNDREDTHS_PER_HOUR * 24;
    const HUNDREDTHS_PER_MONTH = HUNDREDTHS_PER_DAY * ((365 * 4 + 1) / 48);
    const HUNDREDTHS_PER_YEAR = HUNDREDTHS_PER_MONTH * 12;
    intTotalMilliseconds = Math.abs(intTotalMilliseconds);
    HundredthsOfASecond = Math.floor(intTotalMilliseconds / 10);
    const Years = Math.floor(HundredthsOfASecond / HUNDREDTHS_PER_YEAR); // assumed to be 12 "average" months
    HundredthsOfASecond -= Years * HUNDREDTHS_PER_YEAR;
    // assumed to be an "average" month (figures a leap year every 4 years) = ((365*4) + 1) / 48 days - 30.4375 days per month
    const Months = Math.floor(HundredthsOfASecond / HUNDREDTHS_PER_MONTH);
    HundredthsOfASecond -= Months * HUNDREDTHS_PER_MONTH;
    const Days = Math.floor(HundredthsOfASecond / HUNDREDTHS_PER_DAY); // 24 hours
    HundredthsOfASecond -= Days * HUNDREDTHS_PER_DAY;
    const Hours = Math.floor(HundredthsOfASecond / HUNDREDTHS_PER_HOUR); // 60 minutes
    HundredthsOfASecond -= Hours * HUNDREDTHS_PER_HOUR;
    const Minutes = Math.floor(HundredthsOfASecond / HUNDREDTHS_PER_MINUTE); // 60 seconds
    HundredthsOfASecond -= Minutes * HUNDREDTHS_PER_MINUTE;
    const Seconds = Math.floor(HundredthsOfASecond / HUNDREDTHS_PER_SECOND); // 100 hundreths of a seconds
    HundredthsOfASecond -= Seconds * HUNDREDTHS_PER_SECOND;
    if (Years > 0)
        ScormTime += Years + 'Y';
    if (Months > 0)
        ScormTime += Months + 'M';
    if (Days > 0)
        ScormTime += Days + 'D';
    //check to see if we have any time before adding the "T"
    if (HundredthsOfASecond + Seconds + Minutes + Hours > 0) {
        ScormTime += 'T';
        if (Hours > 0)
            ScormTime += Hours + 'H';
        if (Minutes > 0)
            ScormTime += Minutes + 'M';
        if (HundredthsOfASecond + Seconds > 0) {
            ScormTime += Seconds;
            if (HundredthsOfASecond > 0)
                ScormTime += '.' + HundredthsOfASecond;
            ScormTime += 'S';
        }
    }
    if (ScormTime == '')
        ScormTime = '0S';
    ScormTime = 'P' + ScormTime;
    return ScormTime;
}
const timeHandler = (function () {
    const startTime = new Date();
    return {
        getStartTime: startTime,
    };
})();

function ConvertMilliSecondsIntoSCORM12Time(intTotalMilliseconds) {
    let elapsedTime = intTotalMilliseconds;
    const oneSecondInMil = 1000;
    const oneMinuteInMil = oneSecondInMil * 60;
    const oneHoursInMil = oneMinuteInMil * 60;
    const seconds = (elapsedTime / oneSecondInMil) % 60;
    elapsedTime = elapsedTime - seconds * oneSecondInMil;
    const minutes = (elapsedTime / oneMinuteInMil) % 60;
    elapsedTime = elapsedTime - minutes * oneMinuteInMil;
    const hours = elapsedTime / oneHoursInMil;
    return `${addZeroIfLessThan10(hours)}:${addZeroIfLessThan10(minutes)}:${addZeroIfLessThan10(seconds)}`;
}
function addZeroIfLessThan10(val) {
    return val < 10 ? '0' + val.toFixed() : val.toFixed();
}

class Bookmark {
    constructor(currentIndex, currentIndexUid, score, total, biggestIndex, version, lastSlideState, testout) {
        this.currentIndex = 0;
        this.currentIndexUid = '';
        this.score = 0;
        this.total = 0;
        this.biggestIndex = 0;
        this.lastSlideState = {};
        this.version = '0';
        this.elapsedtime = '';
        this.currentIndex = currentIndex;
        this.currentIndexUid = currentIndexUid;
        this.biggestIndex =
            biggestIndex < currentIndex ? currentIndex : biggestIndex;
        this.score = score;
        this.total = total;
        this.version = version;
        this.lastSlideState = lastSlideState;
        this.testout = {
            ...this.testout,
            ...testout,
        };
    }
}

class SCORM_CONST {
}
SCORM_CONST.V_1_DOT_2 = '1.2';
SCORM_CONST.NULL = 'null';
SCORM_CONST.PASSED = 'passed';
SCORM_CONST.FAILED = 'failed';
SCORM_CONST.COMPLETE = 'completed';
SCORM_CONST.INCOMPLETE = 'incomplete';
SCORM_CONST.EXIT = 'exit';
SCORM_CONST.EXIT_ALL = 'exitAll';
SCORM_CONST.CMI = 'cmi';
SCORM_CONST.CMI_SESSION_TIME = `${SCORM_CONST.CMI}.session_time`;
SCORM_CONST.CMI_SUSPEND_DATA = `${SCORM_CONST.CMI}.suspend_data`;
SCORM_CONST.CMI_LOCATION = `${SCORM_CONST.CMI}.location`;
SCORM_CONST.CMI_COMPLETION_STATUS = `${SCORM_CONST.CMI}.completion_status`;
SCORM_CONST.CMI_SUCCESS_STATUS = `${SCORM_CONST.CMI}.success_status`;
SCORM_CONST.CMI_LEARNER_ID = `${SCORM_CONST.CMI}.learner_id`;
SCORM_CONST.CMI_SCALED_PASSING_SCORE = `${SCORM_CONST.CMI}.scaled_passing_score`;
SCORM_CONST.CMI_SCORE = `${SCORM_CONST.CMI}.score`;
SCORM_CONST.CMI_SCORE_SCALED = `${SCORM_CONST.CMI_SCORE}.scaled`;
SCORM_CONST.CMI_SCORE_RAW = `${SCORM_CONST.CMI_SCORE}.raw`;
SCORM_CONST.CMI_SCORE_MIN = `${SCORM_CONST.CMI_SCORE}.min`;
SCORM_CONST.CMI_SCORE_MAX = `${SCORM_CONST.CMI_SCORE}.max`;
SCORM_CONST.CMI_CORE = `${SCORM_CONST.CMI}.core`;
SCORM_CONST.CMI_CORE_SESSION_TIME = `${SCORM_CONST.CMI_CORE}.session_time`;
SCORM_CONST.CMI_CORE_LESSON_STATUS = `${SCORM_CONST.CMI_CORE}.lesson_status`;
SCORM_CONST.CMI_CORE_STUDENT_ID = `${SCORM_CONST.CMI_CORE}.student_id`;
SCORM_CONST.CMI_CORE_SCORE = `${SCORM_CONST.CMI_CORE}.score`;
SCORM_CONST.CMI_CORE_SCORE_MIN = `${SCORM_CONST.CMI_CORE_SCORE}.min`;
SCORM_CONST.CMI_CORE_SCORE_MAX = `${SCORM_CONST.CMI_CORE_SCORE}.max`;
SCORM_CONST.CMI_CORE_SCORE_RAW = `${SCORM_CONST.CMI_CORE_SCORE}.raw`;
SCORM_CONST.ADL = 'adl';
SCORM_CONST.ADL_NAV = `${SCORM_CONST.ADL}.nav`;
SCORM_CONST.ADL_NAV_REQUEST = `${SCORM_CONST.ADL_NAV}.request`;
SCORM_CONST.KB4_THEME = 'kb4.theme';
SCORM_CONST.KB4_ACCOUNT_INFO = 'kb4.info';
SCORM_CONST.KB4_INFO_CLIENT = 'kb4.client';

const SCORM = pipwerksScormApiWrapper.SCORM;
const UTILS = pipwerksScormApiWrapper.UTILS;
let Scorm = class Scorm extends Vue {
    constructor() {
        super();
        this.themeConf = this.getThemeConf();
        this.clientInfo = this.getClientInfo();
        this.scormOptions = this.getDefaultScormOptions();
        this.passingScore = this.themeConf.passing_score
            ? this.themeConf.passing_score
            : 0;
    }
    init(options = this.getDefaultScormOptions()) {
        this.scormOptions = options;
        //SCORM.connection.terminate = this.terminate;
        SCORM.quit = this.terminate;
        this.startTime = timeHandler.getStartTime;
        this.passingScore = this.themeConf.passing_score
            ? this.themeConf.passing_score
            : options.defaultPassingScore;
        if (this.isScormless()) {
            this.log('Scormless setting', 'Package built as SCORMLESS.');
            return;
        }
        SCORM.init();
        this.log('SCORM API VERSION FETCHED', SCORM.version);
    }
    setResults(score, total, callback) {
        const successStatus = this.setResultsAndGetSuccessStatus(score, total);
        if (callback)
            callback();
        return successStatus;
    }
    setThemeConf(themeConf) {
        this.themeConf = themeConf;
    }
    setResultsAndGetSuccessStatus(score, total) {
        let successStatus;
        if (!this.isScormless()) {
            const scoreScaled = total > 0 ? score / total : 0;
            if (scoreScaled >= this.getPassingScore() || total === 0)
                successStatus = this.setCompletion(SCORM_CONST.COMPLETE, true);
            else
                successStatus = this.setCompletion(SCORM_CONST.INCOMPLETE, false);
            this.setScore(total, score, scoreScaled);
        }
        return successStatus;
    }
    getElapsedTime() {
        this.endTime = new Date();
        const elapsedTime = this.endTime.getTime() - this.startTime.getTime();
        const scormTime = ConvertMilliSecondsIntoSCORM2004Time(elapsedTime);
        return scormTime;
    }
    get12ElapsedTime() {
        this.endTime = new Date();
        let startDate = this.startTime;
        let endDate = this.endTime;
        if (startDate > endDate)
            [startDate, endDate] = [endDate, startDate];
        const elapsedTime = endDate.getTime() - startDate.getTime();
        return ConvertMilliSecondsIntoSCORM12Time(elapsedTime);
    }
    finish() {
        if (this.isScormless())
            return;
        this.setSessionTime(this.getElapsedTime());
        SCORM.save();
        SCORM.quit();
    }
    hasSCORMBookmark() {
        const bookmark = SCORM.get(SCORM_CONST.CMI_SUSPEND_DATA);
        const isBookmarkValid = this.isScormBookmarkValid(bookmark);
        this.logWithSuccessFlag(SCORM_CONST.CMI_SUSPEND_DATA, bookmark, isBookmarkValid);
        return isBookmarkValid;
    }
    isScormBookmarkValid(bookmark = '') {
        return bookmark !== SCORM_CONST.NULL && bookmark.length > 0;
    }
    versionHasChanged(bookmark) {
        const suspendDataMajorVersion = this.scormOptions.playerVersion.split('.')[0];
        const bkmrkMajorVersion = bookmark.version.split('.')[0];
        return suspendDataMajorVersion !== bkmrkMajorVersion;
    }
    getBookmark() {
        const bookmarkString = SCORM.get(SCORM_CONST.CMI_SUSPEND_DATA);
        this.log(SCORM_CONST.CMI_SUSPEND_DATA, bookmarkString);
        const bookmark = this.getBookmarkFromString(bookmarkString);
        const location = this.getLocation();
        if (bookmark.currentIndex < location)
            bookmark.currentIndex = location;
        // We need to ignore Score if bookmark score does not reach the passing score
        if (bookmark.total != 0 &&
            bookmark.score / bookmark.total <= this.getPassingScore()) {
            bookmark.score = 0;
            bookmark.total = 0;
        }
        return bookmark;
    }
    getLocation() {
        const location = SCORM.get(SCORM_CONST.CMI_LOCATION);
        this.log(SCORM_CONST.CMI_LOCATION, location);
        return location == '' ? 0 : Number(location);
    }
    getUserId() {
        if (this.isScormless())
            return '';
        return SCORM.version === SCORM_CONST.V_1_DOT_2
            ? SCORM.get(SCORM_CONST.CMI_CORE_STUDENT_ID)
            : SCORM.get(SCORM_CONST.CMI_LEARNER_ID);
    }
    getBookmarkFromString(bookmark = '') {
        try {
            if (this.isScormBookmarkValid(bookmark)) {
                let bookmarkObj = JSON.parse(bookmark);
                bookmarkObj = new Bookmark(bookmarkObj.currentIndex, bookmarkObj.currentIndexUid, bookmarkObj.score, bookmarkObj.total, bookmarkObj.biggestIndex, bookmarkObj.version, bookmarkObj.lastSlideState, bookmarkObj.testout);
                if (bookmarkObj.biggestIndex === undefined)
                    bookmarkObj.biggestIndex = bookmarkObj.currentIndex;
                return bookmarkObj;
            }
        }
        catch (err) {
            console.log('Failed to load suspend data. Reseting');
        }
        return new Bookmark(0, '', 0, 0, 0, this.scormOptions.playerVersion);
    }
    getScaledPassingScore() {
        const scaledPassingScore = SCORM.get(SCORM_CONST.CMI_SCALED_PASSING_SCORE);
        this.log(SCORM_CONST.CMI_SCALED_PASSING_SCORE, scaledPassingScore);
        return !scaledPassingScore ||
            scaledPassingScore === 'null' ||
            scaledPassingScore === '-1'
            ? undefined
            : Number(scaledPassingScore);
    }
    setBookmark(bookmark) {
        if (this.isScormless())
            return;
        bookmark.elapsedtime = this.getElapsedTime();
        this.setSessionTime(this.getElapsedTime());
        this.log('Attempting to save bookmark', bookmark);
        const bookmarkSucceeded = SCORM.set(SCORM_CONST.CMI_SUSPEND_DATA, JSON.stringify(bookmark));
        this.logWithSuccessFlag(SCORM_CONST.CMI_SUSPEND_DATA, JSON.stringify(bookmark), bookmarkSucceeded);
        const locationSucceeded = SCORM.set(SCORM_CONST.CMI_LOCATION, bookmark.currentIndex);
        this.logWithSuccessFlag(SCORM_CONST.CMI_LOCATION, bookmark.currentIndex, locationSucceeded);
        SCORM.save();
    }
    setSessionTime(sessionTime) {
        if (SCORM.version === SCORM_CONST.V_1_DOT_2) {
            sessionTime = this.get12ElapsedTime();
            SCORM.set(SCORM_CONST.CMI_CORE_SESSION_TIME, sessionTime);
            this.log(SCORM_CONST.CMI_CORE_SESSION_TIME, sessionTime);
        }
        else {
            SCORM.set(SCORM_CONST.CMI_SESSION_TIME, sessionTime);
            this.log(SCORM_CONST.CMI_SESSION_TIME, sessionTime);
        }
    }
    getThemeConf() {
        // just mocking the request
        // This brakes the test, as it adds a new first slide. And the tests are not adjusted
        // TODO: change here to test locally
        // const themeConf: ThemeConf = JSON.parse(
        //   '{"color_primary": "#006721","logo": "https://placekitten.com/500/300", "light_mode_allowed":true, "dark_mode_allowed":true, "default_mode":"light", "slides":{"intro": {"image": "https://placekitten.com/512/768","heading": "Welcome to the Course","subheading": "We built a great course, and nobody builds courses better than us. People tell us all the time that these are great, great courses."}, "outro": {"image": "https://placekitten.com/512/768","heading": "That Was the Course","subheading": "Of course it was a course, full of discourse. You had no recourse but to finish the course on this course."}},"contact": {"email": "Email: AcmeCorpAcmeCorpAcmeCorpAcmeCorpAcmeCorpAcmeCorpAcmeCorpAcmeCorpAcmeCorpAcmeCorpAcmeCorp@email.com","phone": "1 1337 8008"}, "social_media": [{"link": "https://twitter.com/SwiftOnSecurity","icon": "fa-twitter", "desc":"Twitter"},{"link": "https://facebook.com/SwiftOnSecurity","icon": "fa-facebook", "desc":"Facebook"},{"link": "https://youtube.com/SwiftOnSecurity","icon": "fa-youtube", "desc":"Youtube"}]}'
        // );
        // return themeConf;
        try {
            const themeConf = JSON.parse(SCORM.get(SCORM_CONST.KB4_THEME));
            this.log(SCORM_CONST.KB4_THEME, themeConf);
            return themeConf;
        }
        catch (err) {
            console.log('Failed to load theme');
            return {};
        }
    }
    getAccountInfo() {
        try {
            const accountInfo = JSON.parse(SCORM.get(SCORM_CONST.KB4_ACCOUNT_INFO));
            this.log(SCORM_CONST.KB4_ACCOUNT_INFO, accountInfo);
            return accountInfo;
        }
        catch (err) {
            console.log('Failed to load Account Info');
            return null;
        }
    }
    getClientInfo() {
        try {
            const clientInfo = SCORM.get(SCORM_CONST.KB4_INFO_CLIENT);
            this.log(SCORM_CONST.KB4_INFO_CLIENT, clientInfo);
            return clientInfo;
        }
        catch (err) {
            console.log('Failed to load Client Info');
            return null;
        }
    }
    getAccountInfoFile() {
        return axios.get('account_info.json');
    }
    getThemeFile() {
        return axios.get('theme.json');
    }
    onLostConnection(error) {
        if (this.isScormless())
            return;
        console.log('Connection Lost');
    }
    setScore(total, score, scoreScaled) {
        if (SCORM.version === SCORM_CONST.V_1_DOT_2) {
            const successMinCall = SCORM.set(SCORM_CONST.CMI_CORE_SCORE_MIN, '0');
            this.logWithSuccessFlag(SCORM_CONST.CMI_CORE_SCORE_MIN, '0', successMinCall);
            const successMaxCall = SCORM.set(SCORM_CONST.CMI_CORE_SCORE_MAX, '100');
            this.logWithSuccessFlag(SCORM_CONST.CMI_CORE_SCORE_MAX, '100', successMaxCall);
            const scoreScaledString = (scoreScaled * 100).toString();
            const successRawCall = SCORM.set(SCORM_CONST.CMI_CORE_SCORE_RAW, scoreScaledString);
            this.logWithSuccessFlag(SCORM_CONST.CMI_CORE_SCORE_RAW, scoreScaledString, successRawCall);
        }
        else {
            SCORM.set(SCORM_CONST.CMI_SCORE_MIN, '0');
            SCORM.set(SCORM_CONST.CMI_SCORE_MAX, total.toString());
            const scoreString = score.toString();
            const successRawCall = SCORM.set(SCORM_CONST.CMI_SCORE_RAW, scoreString);
            this.logWithSuccessFlag(SCORM_CONST.CMI_SCORE_RAW, scoreString, successRawCall);
            const scoreScaledString = scoreScaled.toString();
            const successScaledCall = SCORM.set(SCORM_CONST.CMI_SCORE_SCALED, scoreScaledString);
            this.logWithSuccessFlag(SCORM_CONST.CMI_SCORE_SCALED, scoreScaledString, successScaledCall);
        }
        const saveSucceded = SCORM.save();
        this.log('save', saveSucceded);
    }
    setCompletion(status, hasPassed) {
        if (SCORM.version === SCORM_CONST.V_1_DOT_2) {
            const passingFlag = this.getScorm12PassingFlag(hasPassed);
            const succesLessonStatusCall = SCORM.set(SCORM_CONST.CMI_CORE_LESSON_STATUS, passingFlag);
            this.logWithSuccessFlag(SCORM_CONST.CMI_CORE_LESSON_STATUS, passingFlag, succesLessonStatusCall);
        }
        else {
            const successCompletionCall = SCORM.set(SCORM_CONST.CMI_COMPLETION_STATUS, status);
            this.logWithSuccessFlag(SCORM_CONST.CMI_COMPLETION_STATUS, status, successCompletionCall);
            const passingFlag = hasPassed ? SCORM_CONST.PASSED : SCORM_CONST.FAILED;
            const successStatusCall = SCORM.set(SCORM_CONST.CMI_SUCCESS_STATUS, passingFlag);
            this.logWithSuccessFlag(SCORM_CONST.CMI_SUCCESS_STATUS, passingFlag, successStatusCall);
        }
        const successStatus = hasPassed ? SCORM_CONST.PASSED : SCORM_CONST.FAILED;
        const saveSucceded = SCORM.save();
        this.log('save', saveSucceded);
        return { successStatus: successStatus, completionStatus: status };
    }
    scormErrorInterceptor(error) {
        if (error.indexOf('Can\'t find the API') > -1 ||
            error.indexOf('API connection is inactive') > -1)
            this.onLostConnection(error);
    }
    log(logType, object) {
        if (this.scormOptions.debug) {
            console.log('=== LOG ===');
            console.log(`TYPE: ${logType}`);
            console.log('VALUE:', object);
        }
    }
    logWithSuccessFlag(logType, object, success) {
        if (this.scormOptions.debug) {
            this.log(logType, object);
            console.log('CALL SUCCESS:', success);
        }
    }
    isScormless() {
        return this.scormOptions && this.scormOptions.scormless;
    }
    closeNav() {
        SCORM.set(SCORM_CONST.ADL_NAV_REQUEST, SCORM_CONST.EXIT_ALL);
        this.finish();
    }
    terminate() {
        let success = false;
        const scorm = SCORM, exitStatus = scorm.data.exitStatus, completionStatus = scorm.data.completionStatus, trace = UTILS.trace, makeBoolean = UTILS.StringToBoolean, debug = scorm.debug, traceMsgPrefix = 'SCORM.connection.terminate ';
        console.log('new Terminate used!');
        if (scorm.connection.isActive) {
            const API = scorm.API.getHandle();
            let errorCode = 0;
            if (API) {
                if (scorm.handleExitMode && !exitStatus)
                    if (completionStatus !== 'completed' &&
                        completionStatus !== 'passed') {
                        switch (scorm.version) {
                            case '1.2':
                                success = scorm.set('cmi.core.exit', 'suspend');
                                break;
                            case '2004':
                                success = scorm.set('cmi.exit', 'suspend');
                                break;
                        }
                    }
                    else {
                        switch (scorm.version) {
                            case '1.2':
                                success = scorm.set('cmi.core.exit', '');
                                break;
                            case '2004':
                                success = scorm.set('cmi.exit', 'normal');
                                break;
                        }
                    }
                //Ensure we persist the data
                success = scorm.save();
                if (success) {
                    switch (scorm.version) {
                        case '1.2':
                            success = makeBoolean(API.LMSFinish(''));
                            break;
                        case '2004':
                            success = makeBoolean(API.Terminate(''));
                            break;
                    }
                    if (success)
                        scorm.connection.isActive = false;
                    else {
                        errorCode = debug.getCode();
                        trace(traceMsgPrefix +
                            'failed. \nError code: ' +
                            errorCode +
                            ' \nError info: ' +
                            debug.getInfo(errorCode));
                    }
                }
            }
            else
                trace(traceMsgPrefix + 'failed: API is null.');
        }
        else
            trace(traceMsgPrefix + 'aborted: Connection already terminated.');
        return success;
    }
    getScorm12PassingFlag(hasPasses) {
        const srf = this.themeConf.scorm_result_format || this.getMetadataScormResultFormat();
        this.log('Passing Flags (scorm_1.2)', srf);
        switch (srf) {
            case 'P/I':
                return hasPasses ? SCORM_CONST.PASSED : SCORM_CONST.INCOMPLETE;
            case 'C/I':
                return hasPasses ? SCORM_CONST.COMPLETE : SCORM_CONST.INCOMPLETE;
            case 'C/F':
                return hasPasses ? SCORM_CONST.COMPLETE : SCORM_CONST.FAILED;
            case 'P/F':
            default:
                return hasPasses ? SCORM_CONST.PASSED : SCORM_CONST.FAILED;
        }
    }
    getMetadataScormResultFormat() {
        if (!this.scormOptions)
            return undefined;
        return this.scormOptions.metadataScormResultFormat;
    }
    getPassingScore() {
        return this.passingScore;
    }
    getDefaultScormOptions() {
        const scormOptions = {
            debug: true,
            metadataScormResultFormat: 'P/F',
            playerVersion: 'scorm-default',
            scormless: false,
            defaultPassingScore: 0.8,
        };
        return scormOptions;
    }
};
Scorm = __decorate([
    Component
], Scorm);
var Scorm$1 = Scorm;

// Import vue component

function install(Vue) {
  if (install.installed) return;
  install.installed = true;
  Vue.component('Kb4ScormClient', Scorm$1);
} // Create module definition for Vue.use()


var plugin = {
  install: install
}; // Auto-install when vue is found (eg. in browser via <script> tag)

var GlobalVue = null;
if (typeof window !== 'undefined') GlobalVue = window.Vue;else if (typeof global !== 'undefined') GlobalVue = global.Vue;
if (GlobalVue) GlobalVue.use(plugin); // To allow use as module (npm/webpack/etc.) export component

export default Scorm$1;
export { install };
